import type { FilterRules } from '../models/filter.model'
import type { Story } from '../storyblok'
import type { HeroPlpResponse } from './hero-plp'

export interface CategoryContent {
  component: 'category'
  id: string
  name: string
  description: string
  meta_title: string
  meta_description: string
  hero: HeroPlpResponse[]
  filter_rules?: FilterRules[]
  max_price_range?: string
  xo_tag?: string
  widgetId?: string
  product_list_media_cards?: Story[]
  quick_filters?: Story
  meta_robots?: string[]
  hide_quick_filters?: boolean
}

export type StoryCategory = Story<CategoryContent>

export function isStoryCategory(story: Story): story is StoryCategory {
  return story.content.component === 'category'
}

export interface Category {
  component: 'category'
  id: string
  name: string
  description: string
  metaTitle: string
  metaDescription: string
  hero: HeroPlpResponse[]
  filterRules: FilterRules[]
  maxPriceRange?: number
  xoTag?: string
  widgetId?: string
  productListMediaCards: Story[]
  meta_robots?: string[]
  hideQuickFilters?: boolean
}

export function normalizeCategory(category: StoryCategory): Category {
  const { id, name, description, meta_title, meta_description, hero, filter_rules, max_price_range, xo_tag, widgetId, product_list_media_cards, meta_robots, hide_quick_filters } = category.content

  return {
    component: 'category',
    id,
    name,
    description,
    metaTitle: meta_title,
    metaDescription: meta_description,
    hero,
    filterRules: filter_rules || [],
    maxPriceRange: max_price_range ? Number.parseInt(max_price_range) : undefined,
    xoTag: xo_tag,
    widgetId,
    productListMediaCards: product_list_media_cards ?? [],
    meta_robots,
    hideQuickFilters: hide_quick_filters,
  }
}
